module.exports = __webpack_public_path__ + "img/message.f24971b1.svg";